export default __webpack_public_path__ + "b4aed19c78ebd1765b90d10af8da2f27.png";